import UserProfile from '../../models/userProfile';
export type {UserProfileAttributes} from '../../models/userProfile';
export type {default as UserProfile} from '../../models/userProfile';

import {useCurrentUser} from '@netx/core-user-next/store/currentUser';

export const userProfile = new UserProfile();

// we will import the store for now and keep it up to date
// this eliminates the need for the the store to import this _singleton_ file
// which brings along A LOT of baggage
userProfile
	.on('sync change reset', (model: UserProfile) => {
		useCurrentUser.setState({
			user: {...model.attributes, canCreateAPITokens: model.canCreateAPITokens},
		});
	})
	// Make sure that our current user's profile instance is updated when/if we edit it in the system area:
	.listenTo(dispatcher, 'system:user:edit:success', function (model) {
		model.id == userProfile.id && userProfile.fetch();
	});

export default userProfile;

import {setGlobal} from '@netx/core-next/utils/setGlobal';
// circular dependency
// userProfile relies on this to determine if the profile being edited is the user editing it or not
// will get worked out as we continue switching out data sources
// if (process.env.NODE_ENV !== 'production') {
setGlobal({userProfile});
//}
